import React from "react";

const Footer = () => {
  return (
    <div
      style={{ backgroundColor: "rgb(0, 21, 35)", color: "white" }}
      className="text-center p-3 mt-5"
    >
      2021 &#169; Ashik. All rights reserved.
    </div>
  );
};

export default Footer;
